/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FinopsAssessmentHistory {
    getFixupPrototypeFunction() { return FinopsAssessmentHistory.fixupPrototype; }

    static newInstance(model: Partial<FinopsAssessmentHistory>): FinopsAssessmentHistory {
        let obj = Object.assign(new FinopsAssessmentHistory(), model);
        FinopsAssessmentHistory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FinopsAssessmentHistory>): FinopsAssessmentHistory {
        if (!model) return null;
        return FinopsAssessmentHistory.newInstance(<FinopsAssessmentHistory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FinopsAssessmentHistory) {
        if (!obj) return;

        models.FinopsAssessmentHistory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FinopsAssessmentHistory): boolean {
        Object.setPrototypeOf(obj, FinopsAssessmentHistory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.assessment_start_time === "string") {
            this.assessment_start_time = new Date(<string><any>this.assessment_start_time);
        }
    }

    /**
     * Assessment run id
     */
    assessment_run_id: string;

    /**
     * Assessment run id status
     */
    assessment_status: models.AssessmentRunStatus;

    /**
     * Assessment run id status message
     */
    assessment_status_message: string;

    /**
     * Assessment run start date and time
     */
    assessment_start_time: Date;

}
